import { useEffect } from "react";
import global from "global";

const useFixedWhiteOverlayBugOniOS = () => {
  useEffect(() => {
    // unfortunately, due to the behaviour of ios devices, we have to do this to avoid WD-11379
    if ("scrollRestoration" in global.history) {
      global.history.scrollRestoration = "manual";
    }
  }, []);
};

export default useFixedWhiteOverlayBugOniOS;
